import { Pipe, PipeTransform } from '@angular/core';

import { DealerAssistTableErrorCode } from '../models/communication/baccarat-enums.model';

@Pipe({
    name: 'errorCode',
    standalone: true
})
export class ErrorCodePipe implements PipeTransform {
    transform(value: string, ..._args: unknown[]): string {
        return ErrorCodePipe.stringToDescription(value);
    }

    static stringToDescription(value: string): string {
        switch (value as DealerAssistTableErrorCode) {
            case DealerAssistTableErrorCode.AuthenticationFailed:
                return $localize`Authentication failed`;
            case DealerAssistTableErrorCode.BackendDisconnected:
                return $localize`Backend disconnected`;
            case DealerAssistTableErrorCode.CroupierChangeInvalidState:
                return $localize`Croupier change invalid state`;
            case DealerAssistTableErrorCode.DuplicateCard:
                return $localize`Duplicate card`;
            case DealerAssistTableErrorCode.FlagFailed:
                return $localize`Flag failed`;
            case DealerAssistTableErrorCode.InvalidCard:
                return $localize`Invalid card`;
            case DealerAssistTableErrorCode.InvalidCroupierId:
                return $localize`Invalid croupier ID`;
            case DealerAssistTableErrorCode.RoundOpeningFailed:
                return $localize`Round opening failed`;
            case DealerAssistTableErrorCode.RoundResultSavingFailed:
                return $localize`Round result saving failed`;
            case DealerAssistTableErrorCode.ScannerDisconnected:
                return $localize`Scanner disconnected`;
            default:
                // eslint-disable-next-line no-console
                console.warn(`Unknown error code: ${value}`);
                return value;
        }
    }
}
